import * as React from 'react';
import { useEffect, useState } from 'react';
import { GET_LIST, Loading, translate, withDataProvider, useNotify } from 'react-admin';
import { AnyAction, Dispatch } from 'redux';
import { DataProvider } from 'ra-core';
import { Button, Card, Grid } from '@material-ui/core';
import { DELAY } from '../../utils/config';
import { ImagoCardMediaWithPreview } from './ImagoCardMediaWithPreview';
import { ImagoImagesInterface } from '../../types';

interface DispatchProps {
  dataProvider?: DataProvider;
  dispatch?: Dispatch<AnyAction>;
  keyword: string;
  handleResultCount: any;
  handlePickImage: any;
}

const cardStyle = {
    width: '100%',
    cursor: 'pointer'
};

const cardMediaStyle = {
    paddingTop: '100%'
};

export const ImagoImagesList: React.FunctionComponent<
  DispatchProps
> = translate(
    withDataProvider(props => {
        const { keyword, dataProvider, translate, handleResultCount } = props;
        const imagesInit: ImagoImagesInterface[] = [];
        const [images, setImages] = useState(imagesInit);
        const [resultCount, setResultCount] = useState(0);
        const [page, setPage] = useState(1);
        const [isLoading, setIsLoading] = useState(false);
        const notify = useNotify();

        useEffect(() => {
            if (keyword.length < 2) {
                setPage(0);
                return;
            }
            setIsLoading(true);
            const timer = setTimeout(
                () =>
                    dataProvider(GET_LIST, 'imago', {
                        keyword: keyword,
                        page: page
                    })
                        .then(
                            (response: { data: { pictures: ImagoImagesInterface[]; total: number }}) => {
                                setImages(images.concat(response.data.pictures));
                                setResultCount(response.data.total);
                                setIsLoading(false);
                            }
                        )
                        .catch(error => {
                            notify('resources.asset.notification.service_unavailable', 'warning');
                            console.error(error);
                            setIsLoading(false);
                        }),
                DELAY
            );

            return () => {
                clearTimeout(timer);
            };
            // eslint-disable-next-line
    }, [page]);

        useEffect(() => {
            setImages([]);
            if (keyword.length < 2) {
                setIsLoading(false);
                setPage(0);
                return;
            }
            setIsLoading(true);
            const timer = setTimeout(
                () =>
                    dataProvider(GET_LIST, 'imago', {
                        keyword: keyword,
                        page: page
                    })
                        .then(
                            (response: { data: { pictures: ImagoImagesInterface[]; total: number }}) => {
                                setImages(response.data.pictures || []);
                                setResultCount(response.data.total);
                                handleResultCount(response.data.total);
                                setIsLoading(false);
                            }
                        )
                        .catch(error => {
                            notify('resources.asset.notification.service_unavailable', 'warning');
                            console.error(error);
                            setIsLoading(false);
                        }),
                DELAY
            );

            return () => {
                clearTimeout(timer);
            };
            // eslint-disable-next-line
    }, [keyword]);

        const handleNextPage = () => {
            setPage(page + 1);
        };

        return (
            <>
                <Grid container spacing={1}>
                    {images.map((image, index) => (
                        <Grid key={`${image.pictureid}-${index}`} item xs={1}>
                            <Card style={cardStyle}>
                                <ImagoCardMediaWithPreview handlePickImage={props.handlePickImage} cardMediaStyle={cardMediaStyle} image={image} />
                            </Card>
                        </Grid>
                    ))}
                </Grid>
                <Grid container spacing={1} style={{ padding: 24 }}>
                    <Grid item xs style={{ textAlign: 'center' }}>
                        {isLoading ? (
                            <>
                                <Loading loadingPrimary={null} />
                                <img
                                    alt="Imago Images"
                                    src="https://upload.wikimedia.org/wikipedia/commons/8/86/Imago_Logo.jpg"
                                />
                            </>
                        ) : (
                            keyword.length >= 2 &&
              (resultCount > images.length && (
                  <Button variant={'outlined'} onClick={handleNextPage}>
                      {translate('mam.load_more')}
                  </Button>
              ))
                        )}
                    </Grid>
                </Grid>
            </>
        );
    })
);
